// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-afe0e48a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.top-right-btn[data-v-afe0e48a] {\n  margin-bottom: 10px;\n}\n@media (max-width: 550px) {\n.flex[data-v-afe0e48a] {\n    display: block;\n}\n}", ""]);
// Exports
module.exports = exports;
